import { useForm } from "react-hook-form";
import {
    Flex, Button, VStack,
    FormControl, FormLabel, Icon, FormErrorMessage, HStack,
    useToast
} from '@chakra-ui/react'
import { useUserContext } from "../../context/userContext";
import { putUpdateUserInfo } from "../../classes/User";
import { InputPassword, SectionForm, } from "../shared";
import { BsArrowCounterclockwise, BsBoxArrowInDown } from "react-icons/bs";
import { toastErrDesc, toastVal } from "../../utils/toastUtils";

const ProfileEditPassword = () => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm()
    const { userData } = useUserContext()
    const toast = useToast()

    const resetForm = () => {
        reset()
    }

    const onSubmit = async (data) => {
        await putUpdateUserInfo(userData.id, data, userData.token)
            .then(res => {
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูลของ ${res.full_name} เรียบร้อยแล้ว`,
                }))
            })
            .catch(error => {
                toast(toastVal({
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    return (
        <Flex w="70%" direction="column">
            <form onSubmit={handleSubmit(onSubmit)}>
                <VStack w="full">
                    <SectionForm header="กำหนดรหัสผ่านใหม่">
                        <FormControl isInvalid={errors.password} isRequired>
                            <FormLabel>รหัสผ่านใหม่</FormLabel>
                            <InputPassword control={control} name="password" placeholder="กรอกรหัสผ่าน 6-20 ตัวอักษร" />
                            {errors.password?.type === 'minLength' && <FormErrorMessage>ความยาวรหัสผ่านอย่างน้อย 6 ตัวอักษร</FormErrorMessage>}
                        </FormControl>
                    </SectionForm>
                </VStack>
                <VStack w="full">
                    <HStack mt={4}>
                        <Button type="submit" colorScheme="blue" fontSize="md" leftIcon={<Icon as={BsBoxArrowInDown} />}>
                            บันทึกข้อมูล
                        </Button>
                        <Button type="reset" colorScheme="yellow" fontSize="md" leftIcon={<Icon as={BsArrowCounterclockwise} />} onClick={() => resetForm()}>
                            ล้างฟอร์ม
                        </Button>
                    </HStack>
                </VStack>
            </form>
        </Flex>
    )
}

export default ProfileEditPassword

